<template>

    <div class="text-input-holder">
        <label v-if="label" :for="name">{{label}}</label>
        <input  type="text" v-model="displayValue" :name="name" @blur="isInputActive = false" @focus="isInputActive = true" :disabled="disabled"/>
        <p class="is-danger" v-if="name && errors.has(name)">{{errors.first(name)}}</p>
    </div>

</template>

<script>
    export default {

        mixins:[],
        props: ["value","currency","disabled","name","label"],
        inject: ['$validator'],
        components: {

        },
        data : function(){       
            return {

                isInputActive: false,

            };
        },


        computed: {

            displayValue: {
                get: function() {
                    if (this.isInputActive) {
                        if(this.value === ''){
                            return '';
                        }
                        // Cursor is inside the input field. unformat display value for user
                        return (this.value/100).toString()
                    } else {
                        // User is not modifying now. Format display value for user interface
                        return this.currency.symbol +' ' + (this.value/100).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                    }
                },
                set: function(modifiedValue) {
                    // Recalculate value after ignoring "$" and "," in user input
                    let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ""))
                    // Ensure that it is not NaN
                    if (isNaN(newValue)) {
                        newValue = 0
                    }
                    // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                    // $emit the event so that parent component gets it
                    this.$emit('input', Math.round(newValue*this.currency.denomination));
                }
            }


        },
        created : function(){

        },
        mounted : function ()
        {
        },
        methods:{


        }
    }
</script>



